import type { Product } from "@core/schema/Product.js";

export const productForContactForm = $state<{ current: Product["id"] | undefined }>({ current: undefined });
